(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-meganav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var navs = document.querySelectorAll('[data-cc-meganav]');
    navs.forEach(setupMeganav);

    function setupMeganav(nav) {
      var panel = nav.querySelector('[data-cc-meganav-panel]');
      var panes = nav.querySelectorAll('[data-cc-meganav-pane]');
      var triggers = nav.querySelectorAll('[data-cc-meganav-trigger]');
      if (!panel || triggers.length === 0) return;

      var openTimer = null;
      var closeTimer = null;
      var activeIndex = null;

      function clearTimers() {
        if (openTimer) { clearTimeout(openTimer); openTimer = null; }
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      }

      function showPane(index) {
        clearTimers();
        panel.hidden = false;
        panes.forEach(function (p) {
          p.hidden = parseInt(p.dataset.ccMeganavPane, 10) !== index;
        });
        triggers.forEach(function (t) {
          var target = parseInt(t.dataset.ccMeganavTarget, 10);
          t.setAttribute('aria-expanded', target === index ? 'true' : 'false');
        });
        activeIndex = index;
      }

      function hidePanel() {
        panel.hidden = true;
        panes.forEach(function (p) { p.hidden = true; });
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
        activeIndex = null;
      }

      triggers.forEach(function (trigger) {
        var target = parseInt(trigger.dataset.ccMeganavTarget, 10);
        if (isNaN(target)) return;

        trigger.addEventListener('mouseenter', function () {
          clearTimers();
          if (activeIndex === target) return;
          openTimer = setTimeout(function () { showPane(target); }, 80);
        });

        // Keyboard: ArrowDown / Enter / Space opens the pane and focuses
        // the first link inside it. Escape closes and returns focus.
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            showPane(target);
            var pane = nav.querySelector('[data-cc-meganav-pane="' + target + '"]');
            var firstLink = pane && pane.querySelector('a');
            if (firstLink) firstLink.focus();
          } else if (e.key === 'Escape' && activeIndex !== null) {
            hidePanel();
            trigger.focus();
          }
        });
      });

      nav.addEventListener('mouseleave', function () {
        clearTimers();
        closeTimer = setTimeout(hidePanel, 150);
      });

      nav.addEventListener('mouseenter', clearTimers);

      document.addEventListener('click', function (e) {
        if (activeIndex !== null && !nav.contains(e.target)) hidePanel();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activeIndex !== null) hidePanel();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
